
import { request } from './request'


export function inveniasClient(session, apiSubmissionUrl, apiDocumentUrl) {

	const payload = (object = {}) => JSON.stringify({ session, ...object })

	const send = object => {
		const options = { method: 'PUT', body: payload(object) }
		return fetch(apiSubmissionUrl, options).then(response => response.json())
	}

	const sendField = (name, value) => send({ [name]: value })

	const sendDocument = (name, file, { inveniasParse, onComplete, onError, ...options } = {}) => {
		return new Promise((resolve, reject) => {
			const body = new FormData()
			body.append('key', name)
			body.append('document', file)
			body.append('parse', !!inveniasParse)
			body.append('session', session)
			request({
				body, url: apiDocumentUrl, method: 'POST',
				onComplete: response => resolve(response),
				onError: response => reject(response),
				...options
			})
		})
	}

	const deleteDocument = name => sendField({ [name]: null })

	return { send, sendField, sendDocument, deleteDocument }
}